import { useId } from "react";
import { formatMoneyPreview, parseMoneyInput } from "@/lib/money-entry";

const inputCls =
  "w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500";

export function MoneyInput(props: {
  id?: string;
  label: string;
  symbol?: string;
  value: string;
  onChange: (raw: string, parsed: number | null) => void;
  placeholder?: string;
}) {
  const autoId = useId();
  const id = props.id ?? autoId;
  const symbol = props.symbol ?? "A$";
  const parsed = parseMoneyInput(props.value);
  return (
    <div>
      <label htmlFor={id} className="block text-xs font-medium text-slate-500 mb-1">
        {props.label}
      </label>
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-slate-600 shrink-0">{symbol}</span>
        <input
          id={id}
          inputMode="decimal"
          value={props.value}
          onChange={(e) => props.onChange(e.target.value, parseMoneyInput(e.target.value))}
          className={inputCls}
          placeholder={props.placeholder ?? "24.95"}
          aria-describedby={`${id}-preview`}
        />
      </div>
      <p id={`${id}-preview`} className="mt-1 text-xs text-slate-400">
        {formatMoneyPreview(parsed, symbol)}
      </p>
    </div>
  );
}
